import React, { useState } from "react";
import { Divider, Descriptions, Row as ARow, Col as ACol, Tag, Alert, Image, QRCode, Space } from 'antd';
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var DocumentFooter = function DocumentFooter(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title;
  return /*#__PURE__*/_jsx("div", {
    style: {},
    children: /*#__PURE__*/_jsxs(ARow, {
      gutter: 16,
      style: {
        marginBottom: "45px"
      },
      children: [/*#__PURE__*/_jsx(ACol, {
        className: "gutter-row",
        span: 6,
        children: Common.currentUser.businessAccount != 'undefined' ? /*#__PURE__*/_jsx(Image, {
          preview: false,
          width: "100%",
          src: "/drawables/cl.png"
        }) : /*#__PURE__*/_jsx(Image, {
          preview: false,
          width: "100%",
          src: Common.baseUrl + Common.currentUser.businessAccount.logo
        })
      }), /*#__PURE__*/_jsxs(ACol, {
        span: 16,
        offset: 2,
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            marginBottom: "44px"
          },
          children: [/*#__PURE__*/_jsx("h2", {
            style: {
              padding: "8px 0px 8px 0px",
              textAlign: "center",
              borderBottom: "5px solid #666965"
            },
            children: /*#__PURE__*/_jsx("b", {
              children: Common.account && Common.account.business_label
            })
          }), /*#__PURE__*/_jsx("div", {
            style: {
              color: "#C00000"
            },
            children: /*#__PURE__*/_jsx("b", {
              children: Common.account && Common.account.description
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /*#__PURE__*/_jsx("h4", {
            style: {
              textAlign: "center",
              marginTop: '8px'
            },
            children: /*#__PURE__*/_jsx("b", {
              children: title
            })
          })
        })]
      })]
    })
  });
};

export default DocumentFooter;